// extracted by mini-css-extract-plugin
export var integrationButton = "_ad-0";